// extracted by mini-css-extract-plugin
export default {"button":"ButtonClose_button__5ej0j","button--with-label":"ButtonClose_button--with-label__tr3vI","label":"ButtonClose_label__NYjUy"};